import React from 'react'
import styles from '../styles.module.css'

const TOTAL_COLS = 10

const Table = ({ data }) => {
  if (!data || !data.length) return null

  return (
    <div className={styles.tableBlock}>
      <table className={styles.mainTable} id="hiringPlanTable">
        <thead>
          <tr>
            <th rowSpan={2}>№</th>
            <th rowSpan={2} className={styles.fioCol}>Фамилия, имя, отчество<br />кандидата на обучение</th>
            <th colSpan={5}>Результат сдачи ВИ</th>
            <th rowSpan={2}>Автор обращения</th>
            <th rowSpan={2}>Предложение</th>
            <th rowSpan={2}>Примечание</th>
          </tr>
          <tr>
            <th>Русский язык</th>
            <th>Математика</th>
            <th>Иностр. язык</th>
            <th>ФИЗО</th>
            <th>Общий балл</th>
          </tr>
        </thead>
        <tbody>
          {data.map(org => (
            <React.Fragment key={org.idOrganization}>
              <tr className={styles.orgRow}>
                <td colSpan={TOTAL_COLS}>{org.Orgname}</td>
              </tr>
              {org.classes.map(cls => {
                const vacant = cls.plan - cls.fact
                return (
                  <React.Fragment key={cls.child_class}>
                    <tr className={styles.classRow}>
                      <td colSpan={TOTAL_COLS}>
                        {cls.child_class} класс. Вакантных мест - {vacant} (утверждено - {cls.plan}, налицо - {cls.fact})
                      </td>
                    </tr>
                    {cls.students.map((student, idx) => {
                      const lPrivileged = student.L === '1' || student.L1 === '1'
                      const mPrivileged = student.M === '1'
                      return (
                        <tr key={student.xp_key} className={lPrivileged ? styles.lPrivilegedRow : mPrivileged ? styles.mPrivilegedRow : ''}>
                          <td>{idx + 1}</td>
                          <td className={styles.fioCol}>
                            {`${student.child_lastname?.toUpperCase() ?? ''} ${student.child_firstname} ${student.child_midname}`}
                          </td>
                          <td>{student.Grade_Russian}</td>
                          <td>{student.Grade_Math}</td>
                          <td>{student.Grade_Lang}</td>
                          <td>{student.Grade_PE}</td>
                          <td>{student.Ball}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      )
                    })}
                  </React.Fragment>
                )
              })}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Table
